export default "__VITE_ASSET__CUq4w1YT__"